import { Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export interface SolicitudActivaModalData {
  numeroSolicitud: string;
  /** Si el backend envía `mensaje` en `validacion-solicitud-activa`, se muestra en lugar del texto fijo. */
  mensaje?: string | null;
}

@Component({
  selector: 'app-solicitud-activa-modal',
  standalone: true,
  imports: [NgIf, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './solicitud-activa-modal.component.html',
  styleUrls: ['./solicitud-activa-modal.component.css'],
})
export class SolicitudActivaModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SolicitudActivaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SolicitudActivaModalData
  ) {}

  onClose(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.dialogRef.close();
  }
}
